import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { selectCompanyInfo } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { COVER_PAGE_ID } from '../constant'
import classes from '../index.module.scss'
import { changeActivePanel, selectActivePanel } from '../store/slice'

const CoverPageItem = () => {
  const dispatch = useDispatch()

  const activePanel = useSelector(selectActivePanel)
  const companyInfo = useSelector(selectCompanyInfo)

  const [isHover, setIsHover] = useState(false)

  const isActive = COVER_PAGE_ID === activePanel

  const setActivePanel = () =>
    dispatch(
      changeActivePanel({
        id: COVER_PAGE_ID,
        companyType: companyInfo.companyType,
      }),
    )

  return (
    <Element
      style={{
        width: '100%',
        border: isActive ? '1px solid #2C73E8' : '1px solid #D5D5D5',
        backgroundColor: isActive ? '#C8E3FF' : isHover ? '#EDF5FE' : 'unset',
      }}
      className={`${classes.layoutItem} ${classes.mb4}`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={setActivePanel}
    >
      <Icon className="icon-menu" style={{ fontSize: 8, opacity: 0 }} />
      <div className="flex1 ml1">
        <Translate value="dynamicReport.COVER_PAGE" />
      </div>
    </Element>
  )
}

export default CoverPageItem
